import React from 'react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  label?: string;
  className?: string;
}

const sizeClasses = {
  sm: 'h-6 w-6 border-2',
  md: 'h-8 w-8 border-2',
  lg: 'h-12 w-12 border-t-2 border-b-2',
};

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 'md', 
  label = 'Loading...', 
  className = '' 
}) => {
  return (
    <div role="status" aria-label={label} className={`inline-block ${className}`}>
      <div className={`animate-spin rounded-full ${sizeClasses[size]} border-accent-400 border-t-transparent border-b-transparent`}></div>
      <span className="sr-only">{label}</span>
    </div>
  );
};
